/*
 * @Author: zhangguoliang
 * @Date: 2022-11-14 15:03:22
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-12-07 10:00:40
 */
import { getCMS } from "@/api";
import { onMounted, ref } from "vue";

export default function useCMS(Port: number, pageSize = 100) {
  const data = ref<Record<string, any>[]>([]);
  onMounted(() => {
    getCMS({
      pageNum: 1,
      pageSize,
      Terminal: "pc",
      Port,
    }).then((res) => {
      data.value =
        res.rows.map((item) => {
          if (item.imgUrl?.includes("live-cms-travel")) {
            item.imgUrl += "?x-oss-process=style/style-one";
          }
          return item;
        }) || [];
    });
  });
  return data;
}
